(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["irp-offer-guarantee"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('.io-section button[data-scroll-target]');
  if (!button) return;
  const targetId = (button.dataset.scrollTarget || 'product-section').trim().replace(/^#/, '');
  const target = document.getElementById(targetId)
    || document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
  event.preventDefault();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!target) {
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'instant' : 'smooth' });
    return;
  }
  const offset = Math.max(0, Number(button.dataset.scrollOffset) || 0);
  target.style.scrollMarginTop = `${offset}px`;
  if (!target.hasAttribute('tabindex')) {
    target.setAttribute('tabindex', '-1');
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
  }
  target.focus({ preventScroll: true });
  target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["irp-ritual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('irp-ritual-slider')) {
    customElements.define('irp-ritual-slider', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected) return;
        this.track = this.querySelector('[data-ritual-track]');
        this.cards = Array.from(this.querySelectorAll('[data-ritual-step]'));
        if (!this.track || !this.cards.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = matchMedia('(max-width: 680px)');
        this.counter = this.querySelector('[data-ritual-count]');
        this.previous = this.querySelector('[data-ritual-prev]');
        this.next = this.querySelector('[data-ritual-next]');
        this.controls = this.querySelector('[data-ritual-controls]');
        this.index = 0;
        if (this.controls) this.controls.hidden = false;
        this.previous?.addEventListener('click', () => this.go(this.index - 1), { signal });
        this.next?.addEventListener('click', () => this.go(this.index + 1), { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.sync());
        }, { passive: true, signal });
        this.track.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || event.target !== this.track) return;
          const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.cards.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.go(targets[event.key]);
        }, { signal });
        this.mobile.addEventListener('change', () => this.layout(), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId && this.contains(event.target));
          if (index >= 0) this.go(index, true);
        }, { signal });
        this.observer = new ResizeObserver(() => this.sync());
        this.observer.observe(this.track);
        this.layout();
      }
      layout() {
        if (this.mobile.matches && this.cards.length > 1) this.track.setAttribute('tabindex', '0');
        else this.track.removeAttribute('tabindex');
        this.sync();
      }
      positions() {
        const first = this.cards[0].getBoundingClientRect().left;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        return this.cards.map(card => Math.min(max, Math.max(0, card.getBoundingClientRect().left - first)));
      }
      sync() {
        if (!this.mobile.matches) return;
        const positions = this.positions();
        this.index = positions.reduce((best, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
        const label = `${this.index + 1} / ${this.cards.length}`;
        if (this.counter && this.counter.textContent !== label) this.counter.textContent = label;
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.cards.length - 1;
      }
      go(index, instant = false) {
        if (!this.mobile.matches) return;
        const target = Math.max(0, Math.min(index, this.cards.length - 1));
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.positions()[target], behavior: instant || reduced ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
